"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Theme = _interopRequireDefault(require("../Theme"));

var GlobalCSSCustomProperties = function GlobalCSSCustomProperties(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? (0, _Theme["default"])('bcom') : _ref$theme;
  var ThemedGlobalStyles = (0, _styledComponents.createGlobalStyle)(["", ""], theme.cssVars);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("style", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: "".concat(theme.cssVars)
    }
  }), /*#__PURE__*/_react["default"].createElement(ThemedGlobalStyles, null));
};

GlobalCSSCustomProperties.propTypes = {
  theme: (0, _propTypes.shape)({}).isRequired
};
GlobalCSSCustomProperties.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GlobalCSSCustomProperties",
  "props": {
    "theme": {
      "defaultValue": {
        "value": "getTheme('bcom')",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    }
  }
};
var _default = GlobalCSSCustomProperties;
exports["default"] = _default;